module.exports = __webpack_public_path__ + "img/总部地址.fbd86f78.png";